$(document).ready(function() {

  var weekend_deliveriesSelect = $(document).find('.weekend_deliveriesRadioMain input[type="radio"]:checked').val();
  $(document).find("#cus_dislikes").attr('name','');
  $(document).find("#cus_zipcode").attr('name','');
  $(document).find("#cus_datepicker").attr('name','');
  // $(document).find("#cus_addons").attr('name','');
  $(document).find("#cus_weekendDeliveries").val(weekend_deliveriesSelect);

  $(document).on("keyup change keypress",".dislike-properties input",function() {
    var ths_dislike = $.trim($(this).val());
    if(ths_dislike){
      $(document).find("#cus_dislikes").attr('name','properties[Dislikes]');
      $(document).find("#cus_dislikes").val(ths_dislike);
    }else{
      $(document).find("#cus_dislikes").attr('name','');
      $(document).find("#cus_dislikes").val('');
    }
  });

  $(document).on("keyup change keypress",".product-zipCodeField__input",function() {
    var ths_code = $.trim($(this).val());
    if(ths_code){
      $(document).find("#cus_zipcode").attr('name','properties[_Zip Code]');
      $(document).find("#cus_zipcode").val(ths_code);
    }else{
      $(document).find("#cus_zipcode").attr('name','');
      $(document).find("#cus_zipcode").val('');
    }
  });

  $(document).on("change",".date-pickerMain input",function() {
    var ths_date = $.trim($(this).val());
    if(ths_date){
      $(document).find("#cus_datepicker").attr('name','properties[Start Date]');
      $(document).find("#cus_datepicker").val(ths_date);
    }else{
      $(document).find("#cus_datepicker").attr('name','');
      $(document).find("#cus_datepicker").val('');
    }
  });

  $(document).on('change', '.weekend_deliveriesRadioMain input[type="radio"]',function() {
    var weekend_deliveriesSelectOption = $('.weekend_deliveriesRadioMain input[type="radio"]:checked').val();
    $(document).find("#cus_weekendDeliveries").val(weekend_deliveriesSelectOption);
    
  });

  
  /* if($(document).find('.addon-productsMain').length > 0){
    var additiondata ='';
    $('.addon_inputCheckboxVariant input[type="checkbox"]:checked').each(function() {
      var ths_title = $.trim($(this).val());
      additiondata +=ths_title+',';
    });
    var lastCommaRemoved = additiondata.replace(/,*$/, '');
    if(lastCommaRemoved){
      $(document).find("#cus_addons").attr('name','properties[Addons]');
      $(document).find("#cus_addons").val(lastCommaRemoved);
    }else{
      $(document).find("#cus_addons").attr('name','');
      $(document).find("#cus_addons").val('');
    }
    
    $(document).on('change', '.addon-products input', function(){
      setTimeout(function() {
        var additiondata ='';
        $('.addon_inputCheckboxVariant input[type="checkbox"]:checked').each(function() {
          var ths_title = $.trim($(this).val());
          additiondata +=ths_title+',';
        });
        var lastCommaRemoved = additiondata.replace(/,*$/, '');
        if(lastCommaRemoved){
          $(document).find("#cus_addons").attr('name','properties[Addons]');
          $(document).find("#cus_addons").val(lastCommaRemoved);
        }else{
          $(document).find("#cus_addons").attr('name','');
          $(document).find("#cus_addons").val('');
        }
      }, 500);
    });
  } */
   
  $(document).on('click', '.drawerButtonMain_div .drawerButton_button', function(){
    var dataTitle = $(this).parents('.drawerButtonMain_div').attr('data-title');
    $('.drawerButtonMain_drawerOverlay').each(function(){
      var blockTitle = $(this).attr('block-title');
      if(dataTitle == blockTitle) {
        $(this).addClass('drawerOpen');
        $('body').addClass('custom-drawerOverlay');
      } else {
        $(this).removeClass('drawerOpen');
      }
    });    
  });


  $(document).on('click', '.sample-menu_collectionSection .grid__item.productNotLinking', function(e){
    e.preventDefault();
    var dataTitleSample = $(this).attr('data-title');
    $('.drawerButtonMain_drawerOverlay.samplemenuCollectionDrawer').each(function(){
      var blockTitleSample = $(this).attr('block-title');
      if(dataTitleSample == blockTitleSample) {
        $(this).addClass('drawerOpen');
        $('body').addClass('custom-drawerOverlay');
      } else {
        $(this).removeClass('drawerOpen');
      }
    });    
  });


  $(document).on('click', '.cstm-easysubwidgetbox .cstm-easysubwidgetboxbranding .cstm-easysubwidgetboxbranding-title-details', function(){
    if($('.appDrawerButtonMain_drawerOverlay').length == 1){
      $('.appDrawerButtonMain_drawerOverlay').addClass('drawerOpen');
      $('body').addClass('custom-drawerOverlay');
    }
  });


  $(document).mouseup(function(e) {
    var container = $('.drawerButtonMain_drawer');
    if (!container.is(e.target) && container.has(e.target).length === 0) { 
      $('.drawerButtonMain_drawerOverlay').removeClass('drawerOpen');
      $('body').removeClass('custom-drawerOverlay');
    }
  });

  $(document).on('click', '.drawerButtonMain_drawerClose span', function(){
    $('.drawerButtonMain_drawerOverlay').removeClass('drawerOpen');
    $('body').removeClass('custom-drawerOverlay');
  });


  $('.hiddenVariant_forMatch .inputRadioMain.inputRadioMainHidden:first-child').find('input[type="radio"]').trigger('click');

  var inputValueLoad = '';
    $('.variantSelects .inputCheckboxVariant input[type="checkbox"]:checked').each(function(){
      var checkedValueLoad = $(this).val();
      inputValueLoad += checkedValueLoad+'-';
      newinputValLoad = inputValueLoad.slice(0, -1);
      // console.log('yes' + newinputVal)
      if(newinputValLoad == 'dinner'){
        
        $('.cstm-easysubwidgetboxselectionoption #onetime').trigger('click');
        $('.cstm-easysubwidgetbox').hide();
        
        $('.variant-billingOption .inputRadioMain').each(function(){
          var dataOptionName = $(this).attr('data-option-name');
          $(this).hide();
          $('.variant-billingOption .inputRadioMain[data-option-name="20 Days Package"]').find('input[type="radio"]').trigger('click');
          if(dataOptionName == '20 Days Package' || dataOptionName == '40 Days Package'){
            $(this).show();
          }
        });
      }else{
        
        $('.cstm-easysubwidgetbox').show();
        
        $('.variant-billingOption .inputRadioMain').each(function(){
          var dataOptionName = $(this).attr('data-option-name');
          $(this).show();
          $('.variant-billingOption .inputRadioMain[data-option-name="5 Days Package"]').find('input[type="radio"]').trigger('click');
          if(dataOptionName == '20 Days Package' || dataOptionName == '40 Days Package'){
            $(this).hide();
          }
        });
      }
    });



  
  $(document).on('change', '.inputCheckboxVariant input[type="checkbox"]', function(){
    var inputValue = '';
    $('.variantSelects .inputCheckboxVariant input[type="checkbox"]:checked').each(function(){
      var checkedValue = $(this).val();
      inputValue += checkedValue+'-';
      newinputVal = inputValue.slice(0, -1);
      // console.log('yes' + newinputVal)
      if(newinputVal == 'dinner'){
        
        $('.cstm-easysubwidgetboxselectionoption #onetime').trigger('click');
        $('.cstm-easysubwidgetbox').hide();
        
        $('.variant-billingOption .inputRadioMain').each(function(){
          var dataOptionName = $(this).attr('data-option-name');
          $(this).hide();
          $('.variant-billingOption .inputRadioMain[data-option-name="20 Days Package"]').find('input[type="radio"]').trigger('click');
          if(dataOptionName == '20 Days Package' || dataOptionName == '40 Days Package'){
            $(this).show();
            
          }
        });
      }else{
        
        $('.cstm-easysubwidgetbox').show();
        
        $('.variant-billingOption .inputRadioMain').each(function(){
          var dataOptionName = $(this).attr('data-option-name');
          $(this).show();
          $('.variant-billingOption .inputRadioMain[data-option-name="5 Days Package"]').find('input[type="radio"]').trigger('click');
          if(dataOptionName == '20 Days Package' || dataOptionName == '40 Days Package'){
            $(this).hide();
          }
        });
      }
    });
    
    $('.inputRadioMainHidden [type="radio"]').each(function(){
      var dataValue = $(this).attr('data-value');
      if(newinputVal == dataValue) {
        $(this).trigger('click');
        // $('.main-productSection .product__info-container').addClass('validVariant_select');
      }else{
        // $('.main-productSection .product__info-container').removeClass('validVariant_select');
      }
    });
  });

  var variantDivLength = $('.variantSelects .inputCheckboxVariant').length;
  if(variantDivLength > 0){
    var variantCheckedValue = $('.variantSelects .inputCheckboxVariant input[type="checkbox"]:checked').val();
    if(variantCheckedValue){
      $('.inputRadioMainHidden [type="radio"]').each(function(){
        var dataValue = $(this).attr('data-value');
        if(variantCheckedValue == dataValue) {
          $(this).trigger('click');
        }
      });
    }
  }


  // $('.main-productSection button.add-to-cart-button').attr('disabled', 'disabled');
  $(document).on('change keyup paste', '#input-delivery-zip-code', function(){
    $(this).parents('.product-zipCodeMain').find('.program-delivery-window__input--alertMain').show();
    var zipcodeInputVal = $(this).val();
    $('.zipcodeCodes_all .zipcodeCodes_match').each(function(){
      var data_zipCode = $(this).attr('data-code');
      if(zipcodeInputVal == data_zipCode){
        $(this).parents('.product-zipCodeMain').find('.program-delivery-window__input--alertMain').hide();
      }
    });
  });




  



  const defaults = {
    cartModal: '.cart-notification', // classname
  };
  const cartModal = document.querySelector(defaults.cartModal);

  // $(document).on('click', 'button.add-to-cart-button', function(e){
  //   e.preventDefault();

  //   var checksub = 0;
  //   var sellingPlanID = $('.product-form .selected-selling-plan-id').val();
  // //alert(sellingPlanID)

  //   var sellingPlan_main = $('.cstm-easysubwidgetboxselectionoptionplansselect').find('.cstm-easySellingPlanSelect_selected').attr('data-selling-title');
    

  //   if(sellingPlanID != '' && sellingPlan_main != ''){
  //      checksub = 1;
  //   }

    
  //   let bundleId = Math.floor(Math.random()*100000+1)
  //   $('#bundleId').val(bundleId);
  //   console.log(bundleId)
  //   // return false;
  //   if ($('.addon_inputCheckboxVariant input[type="checkbox"]:checked').length > 0) {
  //     var dataType = [];
  //     $('.addon_inputCheckboxVariant input[type="checkbox"]:checked').each(function() {
  //       var dataSelling = $(this).attr('data-'+sellingPlan_main);
  //       var data = {}; // Create a new object for each iteration
  //       data['id'] = parseInt($(this).attr('data-variant'));
  //       data['quantity'] = 1;
  //       if(checksub == 1){
  //         data['selling_plan'] = dataSelling;
  //       }
  //       data['properties'] = {'bundleId':bundleId};
  //       dataType.push(data);
  //     });
      
  //     const newData = {
  //       items : [...dataType]
  //     }
  //     console.log("data",newData);
  //     jQuery.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       data: newData,
  //       dataType: 'json',
  //       success: function(data) {
  //         console.log(data);
  //         $(document).find('.product-form__submit').trigger('click');
  //         // openAddModal();
  //       }
  //     });
  //   }else{
  //     $(document).find('.product-form__submit').trigger('click');
  //   }

  // });


  $(document).on('click', '.product__accordion.accordion details>summary', function(){
    $(this).parents('.product__accordion.accordion').siblings().find('details').removeAttr('open');
  });

  var cartNotificationSwiper = new Swiper(".cart-notificationAdd_productSlider", {
    spaceBetween: 10,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.itg-swiper-arrow',
      prevEl: '.swiper-button-prev.itg-swiper-arrow'
    },      
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: 2
      },
      989: {
        slidesPerView: 3
      }
    }
  });


  var featuredCollectionsSwiper = new Swiper(".itg-featured_collections .product-grid", {
    spaceBetween: 10,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.itg-swiper-arrow',
      prevEl: '.swiper-button-prev.itg-swiper-arrow'
    },      
    scrollbar: {
        el: ".swiper-scrollbar.itg-swiper-scrollbar"
      },
    breakpoints: {
      320: {
        slidesPerView: 1.15
      },
      480: {
        slidesPerView: 1.75
      },
      640: {
        slidesPerView: 2.25
      },
      1149: {
        slidesPerView: 3.22
      },
    }
  });


  $(document).on('mouseover', '.cart-notificationAdd_product_slideCon', function(){
    $(this).find('.cart-notificationAdd_product_description').slideDown();
  });
  
  $(document).on('mouseleave', '.cart-notificationAdd_product_slideCon', function(){
    $(this).find('.cart-notificationAdd_product_description').slideUp();
  });

  $(document).on('mouseover', '.product-card-wrapper', function(){
    $(this).find('.cart-notificationAdd_product_description').slideDown();
  });
  
  $(document).on('mouseleave', '.product-card-wrapper', function(){
    $(this).find('.cart-notificationAdd_product_description').slideUp();
  });


  $(document).on('mouseover click', '.tab-with-product_tabList h2', function(){
    $(this).parent().addClass('tabActive').siblings().removeClass('tabActive');
    var dataTab = $(this).parent().attr('data-tab');
    $('.tab-with-product__product .tab-with-product__productMain').each(function(){
      var dataProduct = $(this).attr('data-product');
      if(dataTab == dataProduct){
        $(this).addClass('productActive');
      }else{
        $(this).removeClass('productActive');
      }
    });
  });

  // $(document).on('change', '.cstm-easysubwidgetboxselectionoption .cstm-easySubscribeInput', function(){
  //   var subscribeId = $(this).siblings('.cstm-easysubwidgetboxselectionoptionlabel').attr('data--purchase');
  //   $(document).find('.easysubwidgetboxselectionoptionlabel').each(function(){
  //     var dat_purchase = $(this).attr('data-purchase');
  //     if(subscribeId == dat_purchase) {
  //       $(this).trigger('click');
  //       $('.cstm-easysubwidgetboxselectionoptionplans').show();
        
  //       $(document).on('click', '.cstm-easySellingPlanSelect__main .cstm-easySellingPlanSelect_option', function(){
  //         var selectedValue = $(this).find('li[selected]').attr('value');
  //         $('.easysubwidgetboxselectionoptionplans .easysubwidgetboxselectionoptionplansselect select option').each(function(){
  //           var optionValue = $(this).val();
  //           if(selectedValue == optionValue) {
  //             $('.easysubwidgetboxselectionoptionplans .easysubwidgetboxselectionoptionplansselect select').val(optionValue).change();
  //             $('.product-form input[type="hidden"][name="selling_plan"]').val(optionValue);
  //           }
  //         });
  //       });

  //       setTimeout(function(){
  //         var selectedforAddonSub = $('.cstm-easySellingPlanSelect_selected').attr('data-selling-title');
  //         $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //           var matchAddonValSub = $(this).attr('data-title');
  //           if (selectedforAddonSub == matchAddonValSub){
  //             var dataPrice_sub = $(this).attr('data-price');
  //             var dataVarId_sub = $(this).attr('data-id');
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice_sub);
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId_sub);
  //           }else if (selectedforAddonSub == '7-days'){
  //             var dataPrice_sub2 = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option[data-title="7-days"]').attr('data-price');
  //             var dataVarId_sub2 = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option[data-title="7-days"]').attr('data-id');
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice_sub2);
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId_sub2);
  //           }else{
  //             var dataPrice_subFirst = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-price');
  //             var dataVarId_subFirst = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-id');
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice_subFirst);
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId_subFirst);
  //           }
  //         });

  //         $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //           var matchCartNotifyValSub = $(this).attr('data-title');
  //           if (selectedforAddonSub == matchCartNotifyValSub){
  //             var dataPrice_subcart = $(this).attr('data-price');
  //             var dataVarId_subcart = $(this).attr('data-id');
  //             $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice_subcart);
  //             $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId_subcart);
  //           }else if (selectedforAddonSub == '7-days'){
  //             var dataPrice_sub2cart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option[data-title="7-days"]').attr('data-price');
  //             var dataVarId_sub2cart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option[data-title="7-days"]').attr('data-id');
  //             $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice_sub2cart);
  //             $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId_sub2cart);
  //           }else{
  //             var dataPrice_subFirstcart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-price');
  //             var dataVarId_subFirstcart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-id');
  //             $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice_subFirstcart);
  //             $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId_subFirstcart);
  //           }
  //         });
          
  //       }, 100);

  //     } else {
        
  //       $('.cstm-easysubwidgetboxselectionoptionplans').hide();
  //       setTimeout(function(){
  //         $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //           var dataPriceOne = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-price');
  //           var dataVarIdOne = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-id');
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPriceOne);
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarIdOne);
  //         });
          
  //         $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //           var dataPriceOnecart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-price');
  //           var dataVarIdOnecart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-id');
  //           $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPriceOnecart);
  //           $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarIdOnecart);
  //         });
          
  //       }, 100);
        
  //     }


      
  //   });
    
    
  // });


  $(document).on('click', '.cstm-easySellingPlanSelect__main', function(){
    $(this).find('ul[name="cstm-easy_selling_plan"]').toggle();
  });

  // $(document).on('click', '.cstm-easySellingPlanSelect_option li', function(){
  //   var optionTitle = $(this).text();
  //   var optionValue = $(this).attr('value');
  //   var optionTitleHandle = $(this).attr('data-selling-title');
  //   $('.cstm-easySellingPlanSelect_selected .cstm-easySellingPlanSelect_selectedValue').text(optionTitle);
  //   $('.cstm-easySellingPlanSelect_selected').attr('value', optionValue);
  //   $('.cstm-easySellingPlanSelect_selected').attr('data-selling-title', optionTitleHandle);
  //   $(this).attr('selected', 'selected').siblings().removeAttr('selected');

  //   setTimeout(function(){
  //     var selectedforAddon = $('.cstm-easySellingPlanSelect_selected').attr('data-selling-title');
  //     $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //       var matchAddonVal = $(this).attr('data-title');
  //       if (selectedforAddon == matchAddonVal) {
  //         var dataPrice = $(this).attr('data-price');
  //         var dataVarId = $(this).attr('data-id');
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice);
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId);
  //       } else if (selectedforAddon == '7-days') {
  //         var dataPrice2 = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option[data-title="7-days"]').attr('data-price');
  //         var dataVarId2 = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option[data-title="7-days"]').attr('data-id');
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice2);
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId2);
  //       } else {
  //         var dataPriceFirst = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-price');
  //         var dataVarIdFirst = $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addon-variantSelect option:first-child').attr('data-id');
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPriceFirst);
  //         $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarIdFirst);
  //       }
  //     });

  //     $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //       var matchAddonValcart = $(this).attr('data-title');
  //       if (selectedforAddon == matchAddonValcart) {
  //         var dataPricecart = $(this).attr('data-price');
  //         var dataVarIdcart = $(this).attr('data-id');
  //         $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPricecart);
  //         $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarIdcart);
  //       } else if (selectedforAddon == '7-days') {
  //         var dataPrice2cart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option[data-title="7-days"]').attr('data-price');
  //         var dataVarId2cart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option[data-title="7-days"]').attr('data-id');
  //         $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice2cart);
  //         $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId2cart);
  //       } else {
  //         var dataPriceFirstcart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-price');
  //         var dataVarIdFirstcart = $(this).parents('.cart-notification_bestSellers').find('.cart-notification_bestSellers_select option:first-child').attr('data-id');
  //         $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPriceFirstcart);
  //         $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarIdFirstcart);
  //       }
  //     });

  //   }, 200);
    
  // });

  // $(document).on('click', '.cstm-easysubwidgetboxselectionoption', function(){
  //   setTimeout(function(){
  //     var easysubChecked = $('.easysubwidgetbox .easysubwidgetboxselectionoptions').find('.easysubwidgetboxselectionoptionlabel.checked').attr('data-purchase');
  //     if (easysubChecked == 'subscribe') {
  //       $('.main-productSection .product .product-form__input.variant-billingOption').hide();

  //       var easysubscribe__Subscribe = $('.cstm-easySellingPlanSelect__main .cstm-easySellingPlanSelect_option li[selected]').attr('data-selling-title');
  //       console.log('subscribe-----' + easysubscribe__Subscribe)
  //       if(easysubscribe__Subscribe == '5-days'){
  //         $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
  //       } else if(easysubscribe__Subscribe == '7-days') {
  //         $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="7 Days Package"]').trigger('click');
  //       } else if(easysubscribe__Subscribe == '10-days') {
  //         $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="10 Days Package"]').trigger('click');
  //       }else{
  //         $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
  //       }
        
  //       // if($('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="10 Days Package"]').length){
  //       //   var radioVal = $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="10 Days Package"]');
  //       //   $(radioVal).trigger('click');
  //       // }
  //     } else {
  //       $('.main-productSection .product .product-form__input.variant-billingOption').show();

  //       setTimeout(function(){
  //         var programDuration_val = $('.variant-billingOption .inputRadioMain input[type="radio"]:checked').val().toLowerCase();
  //         programDuration_val = programDuration_val.split(' package');
  //         var programDuration_value = programDuration_val[0];
  //         $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //           var matchAddonVal1 = $(this).attr('data-title-lower');
  //           if (programDuration_value == matchAddonVal1){
  //             var dataPrice1 = $(this).attr('data-price');
  //             var dataVarId1 = $(this).attr('data-id');
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice1);
  //             $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId1);
  //           }
  //         });

  //         $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //           var matchAddonVal1cart = $(this).attr('data-title-lower');
  //           if (programDuration_value == matchAddonVal1cart){
  //             var dataPrice1cart = $(this).attr('data-price');
  //             var dataVarId1cart = $(this).attr('data-id');
  //             $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice1cart);
  //             $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId1cart);
  //           }
  //         });
  //       }, 300);
        
  //     }
  //   }, 100);
  // });


  // var topBadgeText = $(document).find('.subscribe_purchase .top-badge #discount').text();
  // $('.cstm-easysubwidgetboxselectionoptionlabel .cstm-easysubwidgetboxselectionoptionlabeltag').text(topBadgeText);


 

  
  $(document).on('change', '.cstm-easysubwidgetboxselectionoption input[type="radio"]', function(){
    uncheckAddons();
    var checkedValueSub = $('.cstm-easysubwidgetboxselectionoption input[type="radio"]:checked').attr('id');
    console.log(checkedValueSub);
    if(checkedValueSub == 'subscribe'){
      $('.cstm-easysubwidgetboxselectionoptionplans').show();
      $('.product .product-form__input.variant-billingOption').hide();
      $('.product .weekend-deliveries').hide();
      $('#cus_weekendDeliveries').val('');
      var SelectedDropdownVal = $('.cstm-easySellingPlanSelect_selected').attr('value');
      var selectedDataTitle = $('.cstm-easySellingPlanSelect_selected').attr('data-selling-title');
      $('.product-form input[type="hidden"][name="selling_plan"]').attr('value', SelectedDropdownVal);

      var subscriptionName = '';
      if(selectedDataTitle == '5-days-only-weekdays' || selectedDataTitle == '5-days'){
        $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
        subscriptionName = '5-days';
      } else if(selectedDataTitle == '7-days-includes-weekends' || selectedDataTitle == '7-days') {
        $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="7 Days Package"]').trigger('click');
        subscriptionName = '7-days';
      } else if(selectedDataTitle == '10-days') {
        $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="10 Days Package"]').trigger('click');
        subscriptionName = '10-days';
      }else{
        $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
        subscriptionName = '5-days';
      }

      $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
        var matchAddonVal2 = $(this).attr('data-title');
        if(subscriptionName){
          if (subscriptionName == matchAddonVal2){
            var dataPrice2 = $(this).attr('data-price');
            var dataVarId2 = $(this).attr('data-id');
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice2);
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId2);
          }
        }
      });


      $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
        var matchAddonVal2cart = $(this).attr('data-title');
        if(subscriptionName){
          if (subscriptionName == matchAddonVal2cart){
            var dataPrice2cart = $(this).attr('data-price');
            var dataVarId2cart = $(this).attr('data-id');
            $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice2cart);
            $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId2cart);
          }
        }
      });
      
    }else{
      $('.cstm-easysubwidgetboxselectionoptionplans').hide();
      $('.product .product-form__input.variant-billingOption').show();
      $('.product .weekend-deliveries').show();
      var customerWeekendDeliveries = $(document).find('.weekend_deliveriesRadioMain input[type="radio"]:checked').val();
      $('#cus_weekendDeliveries').val(customerWeekendDeliveries);
      $('.product-form input[type="hidden"][name="selling_plan"]').attr('value', '');

      $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');

      $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
        var matchAddonVal3 = $(this).attr('data-title');
        if (matchAddonVal3 == '5-days'){
          var dataPrice3 = $(this).attr('data-price');
          var dataVarId3 = $(this).attr('data-id');
          $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice3);
          $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId3);
        }
      });


      $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
        var matchAddonVal3cart = $(this).attr('data-title');
        if (matchAddonVal3cart == '5-days'){
          var dataPrice3cart = $(this).attr('data-price');
          var dataVarId3cart = $(this).attr('data-id');
          $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice3cart);
          $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId3cart);
        }
      });
      
    }
  });




   $(document).on('click', '.cstm-easySellingPlanSelect_option li', function(){
     uncheckAddons();
     console.log('subscribe');
    var optionTitle = $(this).text();
    var optionValue = $(this).attr('value');
    var optionTitleHandle = $(this).attr('data-selling-title');
    $('.cstm-easySellingPlanSelect_selected .cstm-easySellingPlanSelect_selectedValue').text(optionTitle);
    $('.cstm-easySellingPlanSelect_selected').attr('value', optionValue);
    $('.cstm-easySellingPlanSelect_selected').attr('data-selling-title', optionTitleHandle);
    $(this).attr('selected', 'selected').siblings().removeAttr('selected');
     setTimeout(function(){
       $('.product-form input[type="hidden"][name="selling_plan"]').attr('value', optionValue);
     },500);
    
      var subscriptionName = '';
    // var easysubscribe__Subscribe = $('.cstm-easySellingPlanSelect__main .cstm-easySellingPlanSelect_option li[selected]').attr('data-selling-title');
        if(optionTitleHandle == '5-days-only-weekdays' || optionTitleHandle == '5-days'){
          $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
          subscriptionName = '5-days';
        } else if(optionTitleHandle == '7-days-includes-weekends' || optionTitleHandle == '7-days') {
          $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="7 Days Package"]').trigger('click');
          subscriptionName = '7-days';
        } else if(optionTitleHandle == '10-days') {
          $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="10 Days Package"]').trigger('click');
          subscriptionName = '10-days';
        }else{
          $('.main-productSection .product .product-form__input.variant-billingOption .inputRadioMain input[value="5 Days Package"]').trigger('click');
          subscriptionName = '5-days';
        }

      $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
        var matchAddonVal1 = $(this).attr('data-title');
        if(subscriptionName){
          if (subscriptionName == matchAddonVal1){
            var dataPrice1 = $(this).attr('data-price');
            var dataVarId1 = $(this).attr('data-id');
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice1);
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId1);
          }
        }
      });


      $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
        var matchAddonVal1cart = $(this).attr('data-title');
        if(subscriptionName){
          if (subscriptionName == matchAddonVal1cart){
            var dataPrice1cart = $(this).attr('data-price');
            var dataVarId1cart = $(this).attr('data-id');
            $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice1cart);
            $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId1cart);
          }
        }
      });
    
  });
  

  function uncheckAddons(){
    $('.addon-productsMain .addon_inputRadioMain [type="checkbox"]:checked').each(function(){
      $(this).prop("checked", false);
    });
  }
  

    $(document).on('change', '.variant-billingOption .inputRadioMain input[type="radio"]', function(){
    var subCheckedMain = $('.cstm-easysubwidgetboxselectionoption input[type="radio"]:checked').attr('id');
    if (subCheckedMain == 'onetime'){
      setTimeout(function(){
        var programDuration_checked = $('.variant-billingOption .inputRadioMain input[type="radio"]:checked').val().toLowerCase();
        programDuration_checked = programDuration_checked.split(' package');
        var programDuration_checkedvalue = programDuration_checked[0];
        $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
          var matchAddonVal2 = $(this).attr('data-title-lower');
          if (programDuration_checkedvalue == matchAddonVal2){
            var dataPrice2 = $(this).attr('data-price');
            var dataVarId2 = $(this).attr('data-id');
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice2);
            $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId2);
          }
        });
  
        $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
          var matchAddonVal2cart = $(this).attr('data-title-lower');
          if (programDuration_checkedvalue == matchAddonVal2cart){
            var dataPrice2cart = $(this).attr('data-price');
            var dataVarId2cart = $(this).attr('data-id');
            $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice2cart);
            $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId2cart);
          }
        });
      },300);
    }
  });




  

  // $(document).on('change', '.variant-billingOption .inputRadioMain input[type="radio"]', function(){
  //   var easysubCheckedMain = $('.easysubwidgetbox .easysubwidgetboxselectionoptions').find('.easysubwidgetboxselectionoptionlabel.checked').attr('data-purchase');
  //   if (easysubCheckedMain == 'onetime'){
  //     setTimeout(function(){
  //       var programDuration_checked = $('.variant-billingOption .inputRadioMain input[type="radio"]:checked').val().toLowerCase();
  //       programDuration_checked = programDuration_checked.split(' package');
  //       var programDuration_checkedvalue = programDuration_checked[0];
  //       $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //         var matchAddonVal2 = $(this).attr('data-title-lower');
  //         if (programDuration_checkedvalue == matchAddonVal2){
  //           var dataPrice2 = $(this).attr('data-price');
  //           var dataVarId2 = $(this).attr('data-id');
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice2);
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId2);
  //         }
  //       });
  
  //       $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //         var matchAddonVal2cart = $(this).attr('data-title-lower');
  //         if (programDuration_checkedvalue == matchAddonVal2cart){
  //           var dataPrice2cart = $(this).attr('data-price');
  //           var dataVarId2cart = $(this).attr('data-id');
  //           $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice2cart);
  //           $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('value', dataVarId2cart);
  //         }
  //       });
  //     },300);
  //   }
  // });


  //   var easysubCheckedMain = $('.easysubwidgetbox .easysubwidgetboxselectionoptions').find('.easysubwidgetboxselectionoptionlabel.checked').attr('data-purchase');
  //   if (easysubCheckedMain == 'onetime') {
  //     setTimeout(function(){
  //       var programDuration_checked = $('.variant-billingOption .inputRadioMain input[type="radio"]:checked').val().toLowerCase();
  //       programDuration_checked = programDuration_checked.split(' package');
  //       var programDuration_checkedvalue = programDuration_checked[0];
  //       $('.addon_inputRadioMain.addon_inputCheckboxVariant .addon-variantSelect option').each(function(){
  //         var matchAddonVal2 = $(this).attr('data-title-lower');
  //         if (programDuration_checkedvalue == matchAddonVal2){
  //           var dataPrice2 = $(this).attr('data-price');
  //           var dataVarId2 = $(this).attr('data-id');
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('.addonProductPrice').text(dataPrice2);
  //           $(this).parents('.addon_inputRadioMain.addon_inputCheckboxVariant').find('input[type=checkbox]').attr('data-variant', dataVarId2);
  //         }
  //       });
  
  //       $('.cart-notificationAdd_productSlide .cart-notification_bestSellers .cart-notification_bestSellers_select option').each(function(){
  //         var matchAddonVal2cart = $(this).attr('data-title-lower');
  //         if (programDuration_checkedvalue == matchAddonVal2cart){
  //           var dataPrice2cart = $(this).attr('data-price');
  //           var dataVarId2cart = $(this).attr('data-id');
  //           $(this).parents('.cart-notificationAdd_productContent').find('.cart-notificationAdd_product_price').text(dataPrice2cart);
  //           $(this).parents('.cart-notificationAdd_productContent').find('.product-variant-id').attr('data-variant', dataVarId2cart);
  //         }
  //       });
  //     },300);
  //   }

  
  $( function() {
    // Set placeholder to current date
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    var yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;
    // $('#datepicker').attr('placeholder', today);

    // Initialize datepicker with minDate
    // $( "#datepicker" ).datepicker({
    //   minDate: 0
    // });
    function noWeekends(date) {
      var day = date.getDay();
      return [(day != 0 && day != 6), '']; // 0 is Sunday, 6 is Saturday
    }
    
    var date = $('#next_date').attr('data-next');
    $( "#datepicker" ).datepicker({
      minDate: new Date(date),
      beforeShowDay: noWeekends
    });
    
    // Set default date to today
    // $( "#datepicker" ).datepicker("setDate", today);

    // Validate date picker input on form submission
    $(document).on('click change keyup paste', '.date-pickerMain #datepicker', function(event) {
      var dateInput = $('#datepicker').val();

      // Check if date input is empty
      if (dateInput === '') {
        $(this).parents('.date-pickerMain').find('.date-picker-window__input--alertMain').show();
        event.preventDefault(); // Prevent form submission
        return;
      }else{
        $(this).parents('.date-pickerMain').find('.date-picker-window__input--alertMain').hide();
      }

      // Check if date input is a valid date
      var isValidDate = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.test(dateInput);
      if (!isValidDate) {
        $(this).parents('.date-pickerMain').find('.date-picker-window__input--alertMain').show();
        event.preventDefault(); // Prevent form submission
      }else{
        $(this).parents('.date-pickerMain').find('.date-picker-window__input--alertMain').hide();
      }
    });
    
  });


  //$(document).on('click change keyup paste', '.main-productSection product-info input', function(e){
  $(document).on('change keyup paste', '.main-productSection product-info input', function(){
    //e.preventDefault();
    var zipcodeValue = $('.product-zipCodeField__input').val();
    var datePickerValue = $('#datepicker').val();
    var dataProductURL = $('#main-product_section').attr('data-producturl');
      var checkedLength = $('.variantSelects .productVariantOptions input[type="checkbox"]:checked');
      var checkedValue = $('.variantSelects .productVariantOptions input[type="checkbox"]:checked').val();
      // console.log(checkedValue)
      // console.log(checkedLength);
      if (checkedLength.length > 1){
        $('.main-productSection .product__info-container').addClass('validVariant_select');
      }else if (checkedValue == 'dinner'){
        $('.main-productSection .product__info-container').addClass('validVariant_select');
      }else{
        if(dataProductURL == 'detox-meal-delivery'){
          $('.main-productSection .product__info-container').addClass('validVariant_select');
        }else{
          $('.main-productSection .product__info-container').removeClass('validVariant_select');
        }
      }

    $('.zipcodeCodes_all .zipcodeCodes_match').each(function(){
      var data_zipCode = $(this).attr('data-code');
      var validVariantLength = $('.main-productSection .product__info-container.validVariant_select').length;
      //$('.main-productSection button.add-to-cart-button').attr('disabled',true);
      $('.main-productSection button').addClass('add-to-cart-button');
      if(zipcodeValue == data_zipCode  && zipcodeValue != '' && datePickerValue != '' && validVariantLength){
        $(this).parents('.product-zipCodeMain').find('.program-delivery-window__input--alertMain').hide();
        //$('.main-productSection button.add-to-cart-button').attr('disabled',false);
        $('.main-productSection button').removeClass('add-to-cart-button');
        return false;
      }
    });

    
  });

  
  var swiper = new Swiper(".multicolumn-slider", {
    slidesPerView: 4,
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      320:{
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: {
      slidesPerView: 4,
      spaceBetween: 10,
      resistanceRatio : 0
      }
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  
  var confidentialswiper = new Swiper(".main-confidential-container .mySwiper", {
    slidesPerView: 1,
    loop:false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  var customblogswiper = new Swiper(".custom-blog-container .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 10,
        loop: true,
  speed: 800,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
    
    breakpoints: {
      320:{
        slidesPerView: 1
      }, 
  768:{
slidesPerView: 2
  },
      991: {
          slidesPerView: 2.5
      },
      1280: {
          slidesPerView: 3.5
      }
    }
  });

  $(document).on('click', '.home-page-accordian details', function(){
    $(this).parents('.home-page-accordian').siblings().find("details").removeAttr('open');
  });


  // $(document).on('change', '.inputRadioMain.inputCheckboxVariant input[type="checkbox"]', function(){
    
  // });
  
  // setInterval(function () {
    
  //   // Function to get the current date and time in Los Angeles and format each part separately
  //   // Create a new Date object representing the current date and time
  //   const now = new Date();

  //   // Options for formatting different parts
  //   const optionsWeekday = { timeZone: 'America/Los_Angeles', weekday: 'long' };
  //   const optionsDate = { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'long', day: 'numeric' };
  //   const optionsTime = { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };

  //   // Create formatters for each part
  //   const formatterWeekday = new Intl.DateTimeFormat('en-US', optionsWeekday);
  //   const formatterDate = new Intl.DateTimeFormat('en-US', optionsDate);
  //   const formatterTime = new Intl.DateTimeFormat('en-US', optionsTime);

  //   // Format each part
  //   const weekday = formatterWeekday.format(now);
  //   const date = formatterDate.format(now);
  //   const time = formatterTime.format(now);

  //   // Check if the current time is before 1 PM
  //   const optionsHour = { timeZone: 'America/Los_Angeles', hour: 'numeric', hour12: false };
  //   const formatterHour = new Intl.DateTimeFormat('en-US', optionsHour);
  //   const hour = parseInt(formatterHour.format(now), 10);

  //   var expectedDay = "";
  //   if (weekday == 'Monday') {
  //     if (hour < 13) {
  //       var expectedDay = 'Thursday';
  //     } else {
  //       var expectedDay = 'Friday';
  //     }
  //   } else if (weekday == 'Tuesday') {
  //     if (hour < 13) {
  //       var expectedDay = 'Friday';
  //     } else {
  //       var expectedDay = 'Monday';
  //     }
  //   } else if (weekday == 'Wednesday') {
  //     if (hour < 13) {
  //       var expectedDay = 'Monday';
  //     } else {
  //       var expectedDay = 'Tuesday';
  //     }
  //   } else if (weekday == 'Thursday') {
  //     if (hour < 13) {
  //       var expectedDay = 'Tuesday';
  //     } else {
  //       var expectedDay = 'Wednesday';
  //     }
  //   } else if (weekday == 'Friday') {
  //     if (hour < 13) {
  //       var expectedDay = 'Wednesday';
  //     } else {
  //       var expectedDay = 'Thursday';
  //     }
  //   } else if (weekday == 'Saturday') {
  //     var expectedDay = 'Thursday';
  //   } else if (weekday == 'Sunday') {
  //     var expectedDay = 'Thursday';
  //   }

  //   // console.log('Expected Day: ' + expectedDay);
  //   var expectedDay = expectedDay.toLowerCase();
  //   $('.expected-deliveryDay #expectedDay_' + expectedDay).show().siblings().hide();

  //   // console.log('Weekday: ' + weekday);
  //   // console.log('Time: ' + time);
  // }, 1000);



  function printLosAngelesTime(customDate) {

    const [month, day, year] = customDate.split('/').map(Number);
    
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    
    const customDateTime = new Date(year, month - 1, day, hours, minutes, seconds);
    
    const optionsWeekday = { 
      timeZone: 'America/Los_Angeles',
      weekday: 'long' 
    };
    const optionsDate = {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: 'long',
      day: 'numeric' 
    };
    const optionsTime = {
      timeZone: 'America/Los_Angeles', 
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true 
    };
    
    const formatterWeekday = new Intl.DateTimeFormat('en-US', optionsWeekday);
    const formatterDate = new Intl.DateTimeFormat('en-US', optionsDate);
    const formatterTime = new Intl.DateTimeFormat('en-US', optionsTime);
    
    const weekday = formatterWeekday.format(customDateTime);
    const date = formatterDate.format(customDateTime);
    const time = formatterTime.format(customDateTime);
    
    const optionsHour = {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      hour12: false 
    };
    const formatterHour = new Intl.DateTimeFormat('en-US', optionsHour);
    const hour = parseInt(formatterHour.format(customDateTime), 10);
    /* var expectedDay = "";
    if (weekday == 'Monday') {
      if (hour < 13) {
        var expectedDay = 'Thursday';
      } else {
        var expectedDay = 'Friday';
      }
    } else if (weekday == 'Tuesday') {
      if (hour < 13) {
        var expectedDay = 'Friday';
      } else {
        var expectedDay = 'Monday';
      }
    } else if (weekday == 'Wednesday') {
      if (hour < 13) {
        var expectedDay = 'Monday';
      } else {
        var expectedDay = 'Tuesday';
      }
    } else if (weekday == 'Thursday') {
    if (hour < 13) {
        var expectedDay = 'Tuesday';
      } else {
        var expectedDay = 'Wednesday';
      }
    } else if (weekday == 'Friday') {
      if (hour < 13) {
        var expectedDay = 'Wednesday';
      } else {
        var expectedDay = 'Thursday';
      }
    } else if (weekday == 'Saturday') {
      var expectedDay = 'Thursday';
    } else if (weekday == 'Sunday') {
      var expectedDay = 'Thursday';
    } */
    var weekday1 = weekday.toLowerCase();
    $('.expected-deliveryDay #expectedDay_' + weekday1).show().siblings().hide();
  }


  if($('.custom-productSection').length){
    setInterval(function () {
      const customDate = $('.product-datePickerField #datepicker').val(); // Custom date in MM/DD/YYYY format
      if (customDate != ''){
        printLosAngelesTime(customDate);
      }
    }, 1000);
  }


  // $(".tab-heading:first-child").addClass("heading-active");
  // $(".richtext-tab-content:first-child").addClass("tab-deactive");
  $(".tab-heading").click(function () {
    $(".tab-heading").each(function () {
      $(this).removeClass("heading-active");
      $(this).addClass("heading-deactive");
    });
    $(this).addClass("heading-active");
    $(this).removeClass("heading-deactive");
    var datatab = $(this).attr("data-tab");

    $(".richtext-tab-content").each(function () {
      var datatabid = $(this).attr("data-tab-id");
      if (datatab == datatabid) {
        $(this).addClass("tab-active");
        $(this).removeClass("tab-deactive");
      } else {
        $(this).removeClass("tab-active");
        $(this).addClass("tab-deactive");
      }
    });
  });


  //   $(document).on("click", "#checkout", function (event) {
  //     if ($(this).closest(".cart__footer").find("#termscheck").is(":checked")) {
  //       $(this).removeAttr('disabled', 'disabled');
  //     } else {
  //       $(this).attr('disabled', 'disabled');
          
  //     }
  // });

   $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions to checkout.");
        return false;
      }
    });
  


  if(window.matchMedia('(max-width: 749px)').matches){
    
      var tabWithProduct = new Swiper(".tab-with-productMain .mySwiper", {
        slidesPerView: 1.1,
        spaceBetween: 30,
        breakpoints: {
          399: {
              slidesPerView: 1.25
          }
        }
      });

     tabWithProduct.on('transitionEnd', function() {
      $('.tab-with-product_tabList.swiper-slide-active h2').trigger('click');
     });

  }

 
     // tabWithProduct.on('transitionEnd', function() {
     //   $('.tab-with-product_tabList.swiper-slide-active h2').trigger('click');
     // });
  
 

var formCss = setInterval(function() {
    let appEmbed = document.querySelector('#app-embed');
    if (appEmbed) {
        let shadowRoot = appEmbed.shadowRoot;
        if (shadowRoot) {
            let textHeading = shadowRoot.querySelector('._textHeading_2aowh_35');
            if (textHeading) {
                textHeading.setAttribute('style', 'font-size: 36px;line-height: 54px;font-family: var(--font-heading-family); font-weight: 400;');
                clearInterval(formCss); 
            }
        }
    }
}, 200);


var formCssAfter = setInterval(function() {
    let appEmbedAfter = document.querySelector('#app-embed');
    if (appEmbedAfter) {
        let shadowRootAfter = appEmbedAfter.shadowRoot;
        if (shadowRootAfter) {
            let textHeadingAfter = shadowRootAfter.querySelector('._formBannerHeading_1t76a_9');
            if (textHeadingAfter) {
                textHeadingAfter.setAttribute('style', 'font-size: 36px;line-height: 54px;font-family: var(--font-heading-family); font-weight: 400;');
                clearInterval(formCssAfter); 
            }
        }
    }
}, 200);

    const addButton = document.querySelector('[name="add"]');
  const variantInput = document.querySelector('[name="id"]');

  
});